export type Level = "debug" | "info" | "warn" | "error";

export function log(level: Level, msg: string, fields: Record<string, unknown> = {}): void {
  const line = JSON.stringify({
    ts: new Date().toISOString(),
    level,
    msg,
    ...fields,
  });
  const fn =
    level === "error"
      ? console.error
      : level === "warn"
        ? console.warn
        : level === "debug"
          ? console.debug
          : console.info;
  fn(line);
}

export function reportError(err: unknown, fields: Record<string, unknown> = {}): void {
  const e =
    err instanceof Error
      ? { name: err.name, message: err.message, stack: err.stack }
      : { message: String(err) };
  log("error", "reported_error", { ...fields, err: e });
}

export function installErrorHandlers(): void {
  window.addEventListener("error", (ev) =>
    reportError(ev.error ?? ev.message, { source: "window.error" }),
  );
  window.addEventListener("unhandledrejection", (ev) =>
    reportError(ev.reason, { source: "unhandledrejection" }),
  );
}
